module.exports = __webpack_public_path__ + "static/media/front.5ae5a745.jpg";